import { BOOKING_REJECTION_MESSAGES } from "../../services/bookingLimits";

export const ELIGIBILITY_LOADING = "eligibility-loading";

export const getVisibleEligibilityMessage = (message) => (message === ELIGIBILITY_LOADING ? "" : message);

export const getFundEligibilityMessage = (fund, tier, kyc) => {
  if (![2, 3].includes(tier)) return "Complete your Client Application before investing.";
  if (!fund) return ELIGIBILITY_LOADING;
  if (tier === 2) {
    if (fund.fundType === "UITF") return BOOKING_REJECTION_MESSAGES["uitf-tier3-required"];
    if (fund.fundType !== "MF") return BOOKING_REJECTION_MESSAGES["fund-classification-required"];
  }
  if (!kyc) return ELIGIBILITY_LOADING;
  const hasId = (value) => typeof value === "string" && value.trim() !== "";
  const hasTIN = hasId(kyc.ids?.TIN);
  const hasSSS = hasId(kyc.ids?.SSS);
  const accepted = kyc.validated === "verified" || (tier === 2 && kyc.validated === "pending");
  if (fund.fundStats?.requiredValidId &&
      !(accepted && (hasTIN || hasSSS)) && !(tier === 2 && kyc.approvedTier2Id === true)) {
    return "This fund requires a valid TIN/SSS ID.";
  }
  if (fund.fundCompanyDetails?.fundCompanyName === "ATRAM Trust Corporation" &&
      (tier !== 3 || !accepted || !hasTIN)) {
    return "This fund requires TIN and full verification.";
  }
  return "";
};

// Unknown holdings/minimum metadata cannot establish a definitive minimum gate.
export const getApplicableInvestmentMinimum = (fund, holdings) => {
  if (!fund || !Array.isArray(holdings)) return undefined;
  const fundId = fund.id || fund.docId;
  const code = fund.code || fund.fundCode;
  const hasPositiveHolding = holdings.some((holding) => {
    const matches = fundId && holding.fundId ? holding.fundId === fundId : code && holding.fundCode === code;
    const shares = Number(holding.value ?? holding.shares);
    return matches && Number.isFinite(shares) && shares > 0;
  });
  const minimum = Number(hasPositiveHolding ? fund.minAdditionalInvestment : fund.minInitialInvestment);
  return Number.isFinite(minimum) && minimum > 0 ? minimum : undefined;
};

export const getInvestmentEligibilityMessage = (fund, fundEligibility, minimum = 0) => {
  if (fundEligibility?.status !== "ready") return fundEligibility?.error || ELIGIBILITY_LOADING;
  const fundMessage = getFundEligibilityMessage(fund, fundEligibility.data.tier, fundEligibility.kyc);
  if (fundMessage) return fundMessage;
  if (fundEligibility.data.remainingAmount <= 0) return "You have no remaining investment allowance.";
  if (fundEligibility.data.remainingAmount < minimum) return "Your remaining investment allowance is below this fund's minimum investment.";
  return "";
};
